angular.module("servicios", [])
  .service("ContarteApi", ["$http", "API_URL", function ($http, API_URL) {
    this.get = function (request, callback) {
      $http.get(API_URL + request).then(callback);
    };
  }])
  .directive("filtroBusqueda", [function () {

    return {
      restrict: "A",
      template: require("../../../../app/views/Templates/Busqueda/FiltroBusqueda.html"),
      scope: {
        servicio: "@filtroBusqueda",
        eliminarFiltro: "&"
      },
      controller: ["$scope", "ServicioBusqueda", function ($scope, ServicioBusqueda) {
        $scope.mostrarFiltros = false;

        if (!ServicioBusqueda[$scope.servicio]) throw Error("No existe un servicio para " + $scope.servicio);

        var servicio = ServicioBusqueda[$scope.servicio],
          propiedades = servicio.filterProperties,
          propiedadesEspeciales = servicio.filterSpecialProps;

        $scope.removeSearchCriteria = function (filtro, reset) {
          if (reset) {
            servicio.reset();
            $scope.eliminarFiltro({
              opciones: {
                reset: true
              }
            });
          } else {
            var indiceEliminar = $scope.filtros.indexOf(filtro);
            if (indiceEliminar > -1) {
              servicio.unset($scope.filtros[indiceEliminar].filterName);
              $scope.filtros.splice(indiceEliminar, 1);
              $scope.eliminarFiltro({ opciones: { filtro: filtro.filterName } });
            }
          }
        };

        $scope.$watch(function () {
          return servicio.get();
        }, function (parametrosBusqueda) {
          var filtros = [];

          for (var prop in propiedades) {
            var valor = angular.isFunction(propiedadesEspeciales[prop]) ?
              propiedadesEspeciales[prop].call(parametrosBusqueda) : parametrosBusqueda[prop];

            if (!angular.isUndefined(valor) && !(valor === null)) {
              filtros.push({
                filterName: prop,
                title: propiedades[prop],
                value: valor
              });

            }

          }

          $scope.filtros = filtros;

          if (angular.isArray($scope.filtros) && $scope.filtros.length === 0) {
            $scope.mostrarFiltros = false;
          } else {
            $scope.mostrarFiltros = true;
          }

        }, true);

      }]
    };

  }])
  .factory("ServicioBusqueda", ["dateTools", function (dateTools) {

    function Busqueda(paramsIniciales, paramsFiltro, paramsProcesar) {
      var parametros = $.extend({}, paramsIniciales || {});
      var servicio = {};

      servicio.get = function (key) {
        if ($.type(key) === "string") {
          return parametros[key];
        } else {
          return parametros;
        }

      };

      servicio.set = function (key, value) {
        if ($.type(key) === "string") {
          parametros[key] = value;
        } else if ($.type(key) === "object") {
          $.extend(parametros, key);
        }
        return servicio;
      };

      servicio.unset = function (key) {
        if ($.type(key) === "string") {
          delete parametros[key];
        }
        return servicio;
      };

      servicio.reset = function () {
        // Reset parameters to initial values.
        parametros = $.extend({}, paramsIniciales);
        return servicio;
      };

      servicio.filterProperties = paramsFiltro || {};
      servicio.filterSpecialProps = paramsProcesar || {};

      return servicio;

    }

    return {
      BancosTraspasos: Busqueda({
        EstaActivo: true,
        IndiceInicial: 0,
        CantidadRegistrosSolicitados: 15
      },
        {
          NombreCuenta: "Cuenta",
          Fecha: "Fecha"
        },
        {
          Fecha: function () {
            return angular.isString(this.FechaInicio) && angular.isString(this.FechaFin) ?
              dateTools.getDateStringFromWCF(this.FechaInicio, 'DD/MM/YY') + ' a ' + dateTools.getDateStringFromWCF(this.FechaFin, 'DD/MM/YY') : null;
          }
        }),
      BancosReexpresiones: Busqueda({
        EstaActivo: true,
        IndiceInicial: 0,
        CantidadRegistrosSolicitados: 15
      },
        {
          NombreCuenta: "Cuenta",
          Fecha: "Fecha"
        },
        {
          Fecha: function () {
            return angular.isString(this.FechaInicio) && angular.isString(this.FechaFin) ?
              dateTools.getDateStringFromWCF(this.FechaInicio, 'DD/MM/YY') + ' a ' + dateTools.getDateStringFromWCF(this.FechaFin, 'DD/MM/YY') : null;
          }
        }),
      ClientesCobros: Busqueda({
        EstaActivo: true,
        IndiceInicial: 0,
        CantidadRegistrosSolicitados: 15
      },
        {
          Estatus: "Estatus"
        }),
      InicioPolizas: Busqueda({
        CantidadRegistrosSolicitados: 15,
        SoloCanceladas: false
      },
        {
          Detalle: "Detalle",
          Fecha: "Fecha"
        },
        {
          Fecha: function () {
            return angular.isString(this.FechaInicial) && angular.isString(this.FechaFinal) ?
              dateTools.getDateStringFromWCF(this.FechaInicial, 'DD/MM/YY') + ' a  ' + dateTools.getDateStringFromWCF(this.FechaFinal, 'DD/MM/YY') : null;
          }
        }),
      ProveedoresPagos: Busqueda({
        EstaActivo: true,
        IndiceInicial: 0,
        CantidadRegistrosSolicitados: 15
      },
        {
          Estatus: "Estatus"
        })
    };

  }])
  .factory('$httpOnce', ['$http', '$cacheFactory',
    ($http, $cacheFactory) => {
      const cache = $cacheFactory('$httpOnce');

      return (data, clear) => {

        if (clear) {
          cache.remove(data.url);
        }

        return cache.get(data.url) || cache.put(data.url, $http(data)
          .then((response) => {
            return response;
          }));
      };
    }
  ])
  .service("ObtenerUltimosAnios", [function () {
    this.porRango = function (rango) {
      rango = rango || 10;
      const now = new Date().getUTCFullYear();
      return Array(now - (now - rango)).fill('').map((v, idx) => now - idx);
    };
  }]);
